import type { Arc, NarrativeStatus } from './types';

export interface ArcFilters {
  type: ('plot' | 'character')[];
  characterIds: string[];
  narrativeStatus: NarrativeStatus[];
}

export function filterArcsByFilters(
  arcs: Arc[],
  filters: ArcFilters
): Arc[] {
  return arcs.filter((arc) => {
    // Type filter
    if (filters.type.length > 0) {
      if (!filters.type.includes(arc.type)) return false;
    }

    // Character filter
    if (filters.characterIds.length > 0) {
      if (arc.type === 'character') {
         if (!arc.characterId || !filters.characterIds.includes(arc.characterId)) return false;
      } else {
        // Plot arcs don't have characterId, so if we're filtering by specific characters,
        // we might want to exclude plot arcs or not.
        // User said: "if character selected, a characters filter"
        // This implies the character filter only applies when 'character' type is active
        // or it filters character-driven arcs specifically.
        return false;
      }
    }

    // Narrative status filter
    if (filters.narrativeStatus.length > 0) {
      if (!arc.narrativeStatus || !filters.narrativeStatus.includes(arc.narrativeStatus)) return false;
    }

    return true;
  });
}
